// stage
class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    document.addEventListener('DOMContentLoaded', this.init.bind(this));
    this.currentMenuIndex = -1;
    this.isTransitioning = false; // Add state tracking for transitions
  }

  init() {
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
    this.mainDetailsToggle.addEventListener('mouseenter', this.onMouseEnter.bind(this));

    // Add these event listeners during initialization
    const headerWrapper = document.querySelector('.header-wrapper');
    const headerInlineMenu = document.querySelector('.header__inline-menu');
    const logo = document.querySelector('.header__heading');
    const headerIcons = document.querySelector('.header__icons');
    const navOverlay = document.querySelector('.nav-overlay');

    if (headerWrapper) {
      headerWrapper.addEventListener('mouseleave', this.onMouseLeave.bind(this));
    }
    if (headerInlineMenu) {
      headerInlineMenu.addEventListener('mouseleave', this.onMouseLeave.bind(this));
    }

    if (logo) {
      logo.addEventListener('mouseenter', () => {
        this.close();
      });
    }

    if (headerIcons) {
      headerIcons.addEventListener('mouseenter', () => {
        this.close();
      });
    }

    if (navOverlay) {
      navOverlay.addEventListener('mouseenter', () => {
        this.close();
      });
    }

    if (this.content) {
      this.content.addEventListener('mouseenter', () => {
        this.isMouseInSubmenu = true;
      });
    }

    this.toggleIcon();
  }

  toggleIcon() {
    const dropdowns = [...document.querySelectorAll('.dropdown')];

    dropdowns.forEach((dropdown) => {
      const select = dropdown.querySelector('.dropdown__details');
      if (!select) return;

      select.addEventListener('toggle', (e) => {
        const dropdownContainer = e.currentTarget.parentElement;
        const dropdownIcons = dropdownContainer.querySelectorAll('.dropdown__icon');
        dropdownIcons.forEach((icon) => {
          icon.classList.toggle('hidden');
        });
      });
    });
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  onMouseEnter(event) {
    if (this.isTransitioning) return; // Prevent interaction during transition
    this.isTransitioning = true;

    const { mainDetailsToggle } = this;
    const menuIndex = parseInt(mainDetailsToggle.dataset.index, 10);
    const navOverlay = document.querySelector('.nav-overlay');

    navOverlay.classList.add('active');

    // Clear any pending timeouts
    if (this._mouseEnterTimeout) clearTimeout(this._mouseEnterTimeout);
    if (this._mouseLeaveTimeout) clearTimeout(this._mouseLeaveTimeout);

    // Close all other menus first
    const allMenus = document.querySelectorAll('details[open]');
    mainDetailsToggle.querySelector('.header__menu-item').classList.add('active');

    allMenus.forEach((menu) => {
      if (menu !== mainDetailsToggle) {
        menu.removeAttribute('open');
        3;
      }
    });

    const megaMenus = document.querySelectorAll('.mega-menu__content');
    megaMenus.forEach((menu, index) => {
      menu.classList.toggle('active', index === menuIndex);
    });

    const megaItem = document.querySelectorAll('.header__menu-item');
    megaItem.forEach((item, index) => {
      item.classList.toggle('active', index === menuIndex);
    });

    mainDetailsToggle.open = true;
    document.body.classList.add('menu-open');
    this.currentMenuIndex = menuIndex;

    // Reset transition state after animation
    setTimeout(() => {
      this.isTransitioning = false;
    }, 300); // Match your CSS transition duration
  }

  onMouseLeave(event) {
    if (this.isTransitioning) return; // Prevent interaction during transition

    if (this._mouseLeaveTimeout) {
      clearTimeout(this._mouseLeaveTimeout);
    }

    const headerWrapper = document.querySelector('.header-wrapper');
    const headerInlineMenu = document.querySelector('.header__inline-menu');

    if (headerInlineMenu) {
      const rect = headerInlineMenu.getBoundingClientRect();
      const mouseX = event.clientX;
      const mouseY = event.clientY;

      // Add a small buffer zone around the menu
      const buffer = 10;
      const isInBufferZone =
        mouseX >= rect.left - buffer &&
        mouseX <= rect.right + buffer &&
        mouseY >= rect.top - buffer &&
        mouseY <= rect.bottom + buffer;

      if (!isInBufferZone) {
        this.close();
      }
    }

    if (
      headerWrapper &&
      !headerWrapper.contains(event.relatedTarget) &&
      (!event.relatedTarget || !event.relatedTarget.closest('.mega-menu__content'))
    ) {
      this.close();
    }
  }

  close() {
    if (this.isTransitioning) return; // Prevent closing during transition
    this.isTransitioning = true;

    document.body.classList.remove('menu-open', 'overflow-hidden');
    document.documentElement.classList.remove('menu-open');
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
    const navOverlay = document.querySelector('.nav-overlay');

    navOverlay.classList.remove('active');

    // Reset current menu index and hide all mega menus
    this.currentMenuIndex = -1;
    const megaMenus = document.querySelectorAll('.mega-menu__content');
    megaMenus.forEach((menu) => {
      menu.classList.remove('active');
    });

    const megaItem = document.querySelectorAll('.header__menu-item');
    megaItem.forEach((item, index) => {
      item.classList.remove('active');
    });

    // Reset transition state after animation
    setTimeout(() => {
      this.isTransitioning = false;
    }, 300); // Match your CSS transition duration
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`,
    );
  }
}

customElements.define('header-menu', HeaderMenu);
